import { AxiosResponse } from "axios";
import { HanderResponse } from "../_base/helper/FunctionHelper";
import { API_ROUTE } from "../const/apiRoute";
import { api, apiPOS } from "../library/axios";

export const getDataEmployeekdol = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      `${API_ROUTE.GET_LIST_EMPLOYEE_KDOL}?${query}`
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDataEmployeePOS = async (dataSubmit: any): Promise<any> => {
  try {
    const response: AxiosResponse = await apiPOS.post(
      "/api-pos/api/v1/TblDmEmployee/get-list-web",
      dataSubmit
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};
